module.exports = __webpack_public_path__ + "static/Dashboard-0afbb49a7f8653f20540d7ed8961e4c6.png";